import React, { useState } from "react";
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Register from "./Components/register";
import Dashboard from "./Components/dasboard";
import EditCustomer from "./Components/editCustomer";

const App = () => {
  const [custID, setCustID] = useState('');

  console.log('custID :', custID);

  return (
    <Router>
      <Routes>
        <Route path='/' element={<Dashboard setCustID={setCustID} />} />
        <Route path='/register' element={<Register />} />
        <Route path='/editcustomer' element={<Register custID={custID} />} />
        {/* <Route path='/editcustomer/:id' element={<EditCustomer />} /> */}
      </Routes>
    </Router>
  );
};

export default App;
